export * from './swingdev-logo-responsive';
